import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const WOOD_PIECES_ACTIVITY_FRAGMENT = gql `
  fragment WoodPiecesActivityFragment on WoodPiecesActivity {
    rounds {
      affirmationAudio {
        audio {
          ...AssetFragment
        }
      }
      completedAudio {
        audio {
          ...AssetFragment
        }
      }
      instructionAudio {
        audio {
          ...AssetFragment
        }
      }
      introductionAudio {
        audio {
          ...AssetFragment
        }
      }
      letter
      steps {
        stepsPosition: position {
          r
          x
          y
        }
        stroke
        strokeAudio {
          audio {
            ...AssetFragment
          }
        }
        strokeImage {
          image {
            ...AssetFragment
          }
        }
      }
      voice
    }
  }
  ${ASSET_FRAGMENT}
`;
export default WOOD_PIECES_ACTIVITY_FRAGMENT;
